/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize Pth Indicator View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './PthIndicatorView';

export const mapStateToPropsPthIndicator = mapStateToProps;
export const mapDispatchToPropsPthIndicator = mapDispatchToProps;

export default connect(
  mapStateToPropsPthIndicator,
  mapDispatchToPropsPthIndicator
)(View);
